<template>
    <div class="export-orders-list">
        <ab-list-query
        :tabs="tabs"
        :isActive="activedName"
        @handleTabs="handleTabs"
        >
        <template #right>
            <el-row :gutter="20">
                
                <el-col :span="3">
                    <el-input
                        placeholder="订单编号"
                        v-model.trim="formSearch.custOrderNo"
                        clearable
                    >
                    </el-input>
                </el-col>
                <el-col :span="3" >
                    <el-select placeholder="货物状态" v-model="formSearch.businessStatusList" @change="searchForm" clearable multiple>
                        <el-option :label="obj.desc" :value="obj.value" v-for="(obj,idx) in exportStatus" :key="idx"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="3" v-if="!activedName">
                    <el-select  placeholder="订单状态" v-model="formSearch.clientStatus" @change="searchForm" clearable>
                        <el-option label="待提交" value="40"></el-option>
                        <el-option label="待结汇" value="41"></el-option>
                        <el-option label="待付费" value="43"></el-option>
                        <el-option label="已完成" value="45"></el-option>
                    </el-select>
                </el-col>
                
                <el-col :span="3">
                    <ab-select
                        v-if="searchField == 1"
                        v-model="formSearch.customerName"
                        url="/bas/client/basCustomer/list"
                        :urlData="{data: {nameOrNumber: formSearch.customerName}}"
                        inputKey="nameOrNumber"
                        descKey="name"
                        placeholder="境外客户"
                        @handleSelect="customerName"
                    ></ab-select>
                </el-col>
                <el-col :span="4">
                    <ab-timeSearch
                        class="searchBox"
                        startSrc="创建日期起"
                        endSrc="创建日期止"
                        v-model="dateTimeRange"
                        @searchEvent="changeTimeRange"
                    ></ab-timeSearch>
                </el-col>
                
                
                <el-col :span="4">
                    <el-button @click="searchForm" >搜索</el-button>
                    <el-button link class="btn-svg" @click="resetForm"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                </el-col>
            </el-row>
            
        </template>

        <template #toolbar>
            <el-button type="primary" :loading="isAddLoading" @click="handerAdd">新增</el-button>

            <el-button 
            :disabled="selected.length === 0 || selected.some(item => item.payStatusDesc == '已结汇' || item.clientStatus == 1 || item.clientStatus == 4)" 
            :loading="isBtnLoading" 
            @click="showApplyDetail">结汇申请</el-button>

            <el-button 
            :disabled="selected.length === 0" :loading="isBtnLoading" @click="copyAddOrder"
            >复制创建</el-button>
            <el-button 
            :disabled="selected.length === 0 || selected.some(item => item.currentStatusPathDesc == '已完成')" :loading="isBtnLoading" @click="handlerDelete"
            >删除</el-button>
            <el-button 
            :loading="isBtnLoading" @click="handleExport">导出</el-button>
            <el-button :loading="isBtnLoading" :disabled="selected.length == 0" @click="handlePrint">打印</el-button>

            <!-- <div class="batch-download">
                
                <el-popover placement="bottom" popper-class="file-popover" :width="172" trigger="click">
                    <template #reference>
                        <el-button
                            :loading="dlBtnLoading"
                            :disabled="selected.length == 0"
                        >
                        下载文件&nbsp;&nbsp;<el-icon><ArrowDown /></el-icon>
                        </el-button>
                    </template>
                    <el-checkbox
                        style="margin-left:10px"
                        v-model="checkAll"
                        :indeterminate="isIndeterminate"
                        @change="handleCheckAllChange"
                        >全选</el-checkbox
                    >
                    <el-checkbox-group v-model="fileUploadList" @change="handleCheckedCitiesChange">
                        <el-checkbox :label="item.desc"  :key="item.value" v-for="(item, idx) in fileTypeList" />
                    </el-checkbox-group>
                    <el-button
                        plain
                        :loading="dlBtnLoading"
                        @click="downloadFiles"
                        :disabled="fileUploadList.length == 0"
                    >
                    确定下载
                    </el-button>
                </el-popover>
            </div> -->
        </template>
        <template #table>
            <ab-table
                class="materialTable"
                ref="table"
                stripe
                showEdit
                
                showSelection
                selectionWidth="45"
                indexWidth="50"
                showMoreEdit
                widths="200"
                :filterArry="['创建人', '提交人', '订单备注','归类待确认']"
                isFilter="operator"
                :column-list="columns"
                :table-list="tableData"
                :dataListLoading="isloading"
                :handleSelectionChange="handleSelectionChange"
                @filterColumns="filterColumns"
            >
                <template #currentStatusPathDesc="scope">
                    <el-popover
                        placement="right"
                        width="auto"
                        :disabled="!scope.row.currentStatusPathDesc || scope.row.currentStatusPathDesc == '-'"
                        popper-class="orders-prop"
                        trigger="hover"
                        >
                        <div data-v-7647da16="" class="el-steps ab-orders-step el-steps--horizontal">
                            <div data-v-7647da16="" class="el-step is-horizontal is-center" style="width:140px"  v-for="(obj,idx) in scope.row.statusPath" :key="idx" >
                                <div class="el-step__head " :class="getStepClass(obj, scope.row)">
                                <div class="el-step__line" style="margin-right: 0px;">
                                    <i class="el-step__line-inner" ></i>
                                </div>
                                <div class="el-step__icon is-icon"><i class="el-step__icon-inner el-icon-sucs"></i></div>
                                </div>
                                <div class="el-step__main">
                                <div class="el-step__title" :class="getStepClass(obj, scope.row)">{{obj.desc}}<span v-if="obj.isClose && obj.key == 'wait_pay_exchange'">(已关闭)</span></div>
                                <div class="el-step__description" :class="getStepClass(obj, scope.row)">
                                    <span v-if="obj.halfKey == 'wait_class'">{{obj.halfDesc}}</span>
                                    <span v-else>{{obj.date}} </span>
                                </div>
                                </div>
                            </div>
                        </div>
                        <template #reference >
                            <div>
                                <span :class="getStatusClass(scope.row.currentStatusPathDesc)"></span>{{scope.row.currentStatusPathDesc}}
                            </div>
                        </template>
                    </el-popover>
                </template>

                <template #custOrderNo="props">
                    <span class="number-primary" @click="getDetail(props.row)">{{ props.row.custOrderNo }}</span>
                </template>

                <template #toAssortCount="props">
                    <span class="font-primary" @click="jumpToList(props.row)" link>{{ props.row.toAssortCount || 0 }}</span>
                </template>

                <template #businessStatusDesc="props">
                    <span class="font-primary" @click="getBusinessStatus(props.row)">{{ props.row.businessStatusDesc }}</span>
                </template>

                <template #operator="scope">
                    <el-button type="primary" class="is-link" v-if="activedName != '49' && [1, 4].includes(scope.row.clientStatus)" @click="getDetail(scope.row, true)">编辑</el-button>
                    <el-button type="primary" class="is-link" v-else-if=" activedName != '49' && scope.row.payStatusDesc != '已结汇' && ![1, 4].includes(scope.row.clientStatus)" @click="goRemittance(scope.row)">结汇</el-button>
                    <el-button type="primary" class="is-link" v-else-if="activedName != '49' && scope.row.currentStatusPathDesc == '待付费'" @click="$refs.paymentDialog.init(scope.row)">付款</el-button>
                    <el-button type="primary" class="is-link" v-else-if="activedName != '49' && scope.row.clientStatus != 1"  @click="getStatusTimeAxis(scope.row.id, scope.row.bizType)">进度</el-button>
                    <el-button type="primary" class="is-link" v-else-if="activedName != '49'" @click="getDetail(scope.row)">详情</el-button>
                    <el-button  type="primary" class="is-link" v-if="this.activedName == 49"  @click="$refs.evaluate.init(scope.row)">评价</el-button>
                </template>
                <template #moreOper="scope">
                    <el-button type="primary" class="is-link" v-if="[1, 4].includes(scope.row.clientStatus)" @click="getDetail(scope.row, true)">编辑</el-button>
                    <el-button type="primary" class="is-link" v-if="scope.row.payStatusDesc != '已结汇' && ![1, 4].includes(scope.row.clientStatus) && scope.row.statusDesc != '已作废'" @click="goRemittance(scope.row)">结汇</el-button>
                    <el-button type="primary" class="is-link" @click="getDetail(scope.row)">详情</el-button>
                    <el-button type="primary" class="is-link" v-if="scope.row.currentStatusPathDesc == '待付费'" @click="$refs.paymentDialog.init(scope.row)">付款</el-button>
                    <el-button type="primary" class="is-link" v-if="scope.row.clientStatus != 1" @click="getStatusTimeAxis(scope.row.id, scope.row.bizType)">进度</el-button>
                    <el-button type="primary" class="is-link" @click="showDownDialog(scope.row)" >下单证</el-button>
                </template>

            </ab-table>
            <div v-if="this.selected && this.selected.length">已选订单总额：<span style="color:red">{{ selectSum }}</span></div>
        </template>
        <template #page>
            <ab-page
                :pageTotal="page.total" 
                :currentPage='page.currentPage' 
                :pageSize="page.pageSize" 
                :pageSizes="page.pageSizes"
                @searchForm="pageSearch"
            ></ab-page>
        </template>
       
        </ab-list-query>
        <payment-dialog ref="paymentDialog" sourceType="export" @offline="offlinePay" @success="searchForm"></payment-dialog>
        <el-drawer v-model="logvisible" title="物流进度">
            <ab-logistics-status ref="logistics-status">
            </ab-logistics-status>
        </el-drawer>
        <ab-downloadFile :dialog="uploadParams"></ab-downloadFile>

        <!-- 补快递单号弹框 -->
      <el-dialog
        :close-on-click-modal="false"
        class="no-min-height"
        width="400px"
        @closed="closeDialog"
        title="请录入快递单号"
        v-model="repairNumberVisible">
        <el-form ref="repairDialog" :model="repairDialog">
          <el-form-item label="" prop="supplierCarrierId" :rules="[
              { required: true, message: '请选择运输商', trigger: ['change', 'blur'] }
            ]">
            <el-select size="mini" style="margin-bottom: 10px" v-model="repairDialog.supplierCarrierId" placeholder="请选择运输商">
              <el-option
              v-for="item in listCarrier"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="supplierCourierNumber" :rules="[
              { required: true, message: '请填写快递单号', trigger: ['change', 'blur'] }
            ]">
              <el-input size="mini" :disabled="!repairDialog.supplierCarrierId" maxlength="200" placeholder="请录入单号（不含快递公司名字）" v-model="repairDialog.supplierCourierNumber"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button type="primary" :loading="supplierLoading" @click="confirmDialog">确定</el-button>
                <el-button :loading="supplierLoading" @click="repairNumberVisible = false">取消</el-button>
            </span>
         </template>
      </el-dialog>
      <evaluateDialog ref="evaluate" @changeList="searchForm"></evaluateDialog>
    </div>
</template>

<script>
import paymentDialog from './payment-dialog'
import evaluateDialog from './evaluate-dialog'
export default {
    name: 'export-orders-list',
    components: {
        paymentDialog,
        evaluateDialog
    },
    data () {
        return {
            searchField: '1',
            isAddLoading: false,
            tabs: [
                {name: '全部', value: '', state: ''},
                {name: '待提交', value: '', state: '40'},
                {name: '待结汇', value: '', state: '41'},
                {name: '待付费', value: '', state: '43'},
                {name: '待评价', value: '', state: '49'},
                {name: '已完成', value: '', state: '45'},
            ],
            formSearch: {},
            dateTimeRange: '',
            page: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            },
            columns: [
                {
                    props: 'custOrderNo',
                    labels: '订单编号',
                    widths: 140,
                    sort: 'custom',
                    slot: 'slot'
                },
                {
                    props: 'bizDate',
                    labels: '创建日期',
                    align: 'center',
                    sort: 'custom',
                    widths: 100
                },
                {
                    props: 'currentStatusPathDesc',
                    labels: '订单状态',
                    align: 'center',
                    widths: 80,
                    slot: 'slot'
                },
                {
                    props: 'businessStatusDesc',
                    labels: '货物跟踪',
                    align: 'center',
                    widths: 80,
                    slot: 'slot'
                },
               
                {
                    props: 'customerName',
                    labels: '境外客户',
                    widths: 200
                },
            
                {
                    props: 'totalAmount',
                    labels: '订单金额',
                    align: 'right',
                    type: 'money',
                    widths: 120
                },
                {
                    props: 'currencyName',
                    labels: '币别',
                    align: 'left',
                    widths: 60
                },
                
                {
                    props: 'createByName',
                    labels: '创建人',
                    widths: 100
                },
                {
                    props: 'confirmByName',
                    labels: '提交人',
                    widths: 100,
                },
                {
                    props: 'remark',
                    labels: '订单备注',
                    widths: 100,
                },
            ],
            tableData: [],
            isloading: false,
            activedName: '',
            selected: [],
            isBtnLoading: false,
            logvisible: false,
            dataInfo: {},
            exploading: false,
            uploadParams: {
                title: '单证下载',
                coreBillIds: "",
                coreBillNumbers: "",
                sourceBillId: "",
                sourceBillNumber: "",
                sourceBillType: "EntrustAll",
                billsType: "",
                show: false,
                url: '/oms/client/entrustStatus/getAllNodesAttach',
                items: []
            },
            repairNumberVisible: false,
            repairDialog: {supplierCarrierId: ''},
            supplierLoading: false,
            fileType: [],
            dlBtnLoading: false,
            fileTypeList: [],
            fileTypeListTemp: [
                {
                    desc: '报关单',
                    value: 'CustomsDeclaration_010'
                },
                {
                    desc: '海关缴款书',
                    value: 'TaxList_010'
                },
                {
                    desc: '放行通知书',
                    value: 'CustomsDeclaration_020'
                },
                {
                    desc: '收货登记',
                    value: 'AccessionNumber_010'
                },
                {
                    desc: '签收单',
                    value: 'LogisticsNotice_030'
                },
                {
                    desc: '进口货物确认单',
                    value: 'EntrustAll_010'
                },
                {
                    desc: '增值税发票',
                    value: 'DrawInvoice_020'
                }
            ],
            exportStatus: [],
            fileUploadList: [],
            checkAll: false,
            isIndeterminate: true,

        }
    },
    activated() {
        if(this.$route.query.activedName) {
            this.activedName = ''
            this.resetForm()
            if(this.$route.query.activedName == '41' || this.$route.query.activedName == '43') {
                this.handleTabs(this.$route.query.activedName)
            }else{
                this.getStatusList(this.$route.query.activedName)
            }
            return
        }
        this.getListData()
    },
    created() {
        this.getclientGetDDL()
        this.getStatusList()
    },
    computed: {
        dlBtnDisabled() {
            const selectNum = this.selected.length
            if (selectNum === 0 || this.fileType.length === 0) {
                return true
            } else {
                if (this.fileType.length === this.fileTypeList.length) { // 全选
                return selectNum > 10 
                } else if (this.fileType.length > 1) { // 多个
                return selectNum > 20 
                } else if (this.fileType.length === 1) { // 单个
                return selectNum > 50
                }
            }
            return false
        },
        selectSum () {
            let sum = 0
            this.selected.map(e => {
                sum = this.$calc.add(sum, e.totalAmount)
            })
            return this.$filters.formatMoney(sum)
        }
    },
    methods: {
        getShow(row){
            let a = ['待提交'].includes(row.currentStatusPathDesc) && row.signatureStatus != '02'
            let b = row.clientStatus == 5 && row.signatureStatus == '02'
            let c = ['待付费'].includes(row.currentStatusPathDesc) && !['delivery_signed', 'delivery_part_signed'].includes(row.businessStatus)
            let d = row.payStatusDesc != '已付汇' && ['待付汇','部分付汇'].includes(row.currentStatusPathDesc)
            let e = ['待报关', '待签收','付款中'].includes(row.currentStatusPathDesc)
            let f = ['已完成'].includes(row.currentStatusPathDesc)
            let g = ['待付费'].includes(row.currentStatusPathDesc) && ['delivery_signed', 'delivery_part_signed'].includes(row.businessStatus)
            let start = !a && !b && !c && !d && !e && !f && !g
            return start
        },
        customerName(v) {
            if (v.id) {
                this.formSearch.customerName = v.name
                this.formSearch.customerId = v.id
            } else {
                this.formSearch.customerName = ''
                this.formSearch.customerId = ''
            }
            this.searchForm()
        },
        resField() {
            this.formSearch.customerName = ''
            this.formSearch.customerId = ''
            this.formSearch.remark = ''
        },
        fileTypeDisbaled () {
            let flag = false
            this.selected.map(e => {
                if (e.bizType == '01') {
                    flag = true
                }
            })
            return flag
        },
        handleSelectionChange (val) {
            this.selected = val
            if (this.fileTypeDisbaled()) {
                this.fileTypeList = this.fileTypeListTemp.filter(e => {
                    return e.value != 'CustomsDeclaration_010' && e.value != 'TaxList_010' && e.value != 'CustomsDeclaration_020'
                })
            } else {
                this.fileTypeList = this.fileTypeListTemp
            }
        },
        searchForm () {
            this.page.currentPage = 1
            this.getListData()
        },
        pageSearch (obj) {
            this.page.currentPage = obj.currentPage
            this.page.pageSize = obj.pageSize
            this.getListData()
        },
        getListData () {
            this.isloading = true
            this.$post('/oms/client/entrustExport/list', {
                data: {
                    custOrderNo: this.formSearch.custOrderNo,
                    customerId: this.formSearch.customerId,
                    clientStatus: this.formSearch.clientStatus,
                    businessStatusList: this.formSearch.businessStatusList
                },
                    sortName: this.sortName,
                    order: this.order,
                    pageNum: this.page.currentPage, 
                    pageSize: this.page.pageSize,
                params: {
                    bizDateBegin: this.formSearch.bizDateBegin, 
                    bizDateEnd: this.formSearch.bizDateEnd
                }
            }).then(res => {
                if (res.data.code == 'C0000') {
                    this.tableData = res.data.result.list
                    this.page.total = res.data.result.total
                    this.tableData.forEach((e)=>{
                        e.detailDisplay = this.getShow(e)
                    })
                    this.tabs.map(e => {
                        if (e.name == '待提交') {
                            e.value = res.data.extra && res.data.extra.waitSubmitCount || 0
                        } else if (e.name == '待结汇') {
                            e.value = res.data.extra && res.data.extra.waitPayExchangeCount || 0
                        } else if (e.name == '待付费') {
                            e.value = res.data.extra && res.data.extra.waitPayFeeCount || 0
                        }else if (e.name == '待评价') {
                            e.value = res.data.extra && res.data.extra.waitEvaluation || 0
                        }
                    })
                }
            }).finally(() => {
                this.isloading = false
            })
        },
        getStatusClass (status) {
            let cls = ''
            switch (status) {
                case '待付费':
                case '待签章': 
                cls = 'status-13227A'
                break
                case '已拆单':
                    cls = 'status-B1B1B1'
                break
                case '待提交':
                    cls = 'status-E21010'
                break
                case '待签收':
                    cls = 'status-FF8400'
                break
                case '待付汇':
                case '待结汇':
                case '部分付汇':
                    cls = 'status-1165D4'
                break
                case '待报关':
                    cls = 'status-8C10E2'
                break
                case '已完成':
                case '已签收':          
                case '已下单':
                    cls = 'status-0AB2A8'
                    break
                default:
                    cls = 'status-B1B1B1'
            }
            return cls
        },
        filterColumns (array) {
            this.columns = array
        },
        getStepClass(obj, row) {
            let str = ''
            if (row.currentStatusPath == obj.key) {
                str = 'is-finish'
            } else if (obj.date && !obj.isClose) {
                str = 'is-finish'
            } else {
                str = 'is-wait'
            }
            return str
        },
        jumpToList(row) {
            this.$router.push({
                path: '/classification-confirm-list',
                query: {
                    active: 'pending',
                    entrustNumber: row.custOrderNo
                }
            })
        },
        handerAdd () {
            this.$router.push({
                path: '/export-orders-detail',
                query: { status: 'add', cache: false}
            })
        },
        getDetail (row) {
            this.$router.push({
                path: '/export-orders-detail',
                query: { status: 'edit', cache: false, id: row.id}
            })
        },
        handleTabs (item) {
            this.activedName = item
            this.formSearch.clientStatus =  item
            this.getListData()
        },
        resetForm () {
            this.formSearch = {}
            this.supplierName = ''
            this.dateTimeRange = ''
        },
        showApplyDetail (obj) {
            console.log(obj)
            let arr = obj && obj.id ? [obj] : this.selected
            if(arr.length === 0) {
                this.$message({
                    type: 'error',
                    message: '请选择需付款的订单',
                    offset: 380,
                    grouping: true,
                })
            }else {
                this.isloading = true
                let ids = arr.map(e => {return e.id})
                this.$post('/sms/client/paymentSettle/toPayByBill', arr).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    data.result.paymentAppBackVoList = data.result.paymentAppBackVoList || []
                    data.result.paymentAppCustomsVoList = data.result.paymentAppCustomsVoList || []
                    data.result.paymentAppGeneralEntryVoList = data.result.paymentAppGeneralEntryVoList || []
                    data.result.paymentAppPayVoList = data.result.paymentAppPayVoList || []
                    data.result.paymentAppPreEntrustVoList = data.result.paymentAppPreEntrustVoList || []
                    data.result.paymentAppRevVoList = data.result.paymentAppRevVoList || []
                    data.result.paymentAppSumAmountVos = data.result.paymentAppSumAmountVos || []
                    this.$router.push({
                        path: '/exchange-settlement-detail',
                        query: {
                            action: 'import',
                            result: JSON.stringify(data.result),
                            cache: false,
                            edit: true
                        }
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: data.message,
                        offset: 380,
                        grouping: true,
                    })
                }
                }).finally(() => {
                    this.isloading = false
                })
            }
        },
        copyAddOrder () {
            if (this.selected.length > 1) {
                this.$message({
                    type: 'error',
                    message: '只能选择一条数据',
                    offset: 380,
                    grouping: true,
                })
            } else if (this.selected.length === 1) {
                this.$router.push({
                    path: '/export-orders-detail',
                    query: { copy: this.selected[0].id, cache: false, status: 'copy'}
                })
            }
        },
        handlerDelete () {
            let ids = [],flag = true
            this.selected.map(e => {
                if (![1,4].includes(e.clientStatus)) {
                flag = false
                }
                ids.push(e.id)
            })
            if (!flag) {
                this.$message({
                    type: 'error',
                    message: '单据状态已保存，已退回的数据才可以删除！',
                    offset: 380,
                    grouping: true,
                })
                return false
            }
            this.$confirm('确定要删除吗?', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning'
            }).then(() => {
                this.isBtnLoading = true
                this.$post('/oms/client/entrustExport/batchDel?ids=' + ids).then((res) => {
                    if (res.data.code == 'C0000') {
                        this.selected = []
                        this.$message({
                            type: 'success',
                            message: res.data.message,
                            offset: 380,
                            grouping: true,
                        })
                        this.getListData()
                    }
                }).finally(() => {
                    this.isBtnLoading = false
                })
            })
        },
        handleExport () {
            let excelField = []
            this.columns.map(e => {
                excelField.push(e.props)
            })
            this.isBtnLoading = true
            this.$post('/oms/client/entrustExport/clientBatchExport', 
                {
                    pageNum: this.page.currentPage,
                    pageSize: this.page.pageSize,
                    data: {
                        clientStatus: this.formSearch.clientStatus,
                        custOrderNo: this.formSearch.custOrderNo,
                        customerId: this.formSearch.customerId,
                        businessStatusList: this.formSearch.businessStatusList
                    },
                    excelField: this.columns.map(item => { return item.props }),
                    colTitleMapList: this.columns,
                    params: {
                    bizDateBegin: this.formSearch.bizDateBegin,
                    bizDateEnd: this.formSearch.bizDateEnd
                }
            }).then(res => {
                if (res.data.code == 'C0000') {
                    let eleLink = document.createElement('a')
                    eleLink.download = ''
                    eleLink.style.display = 'none'
                    eleLink.href = res.data.result
                    document.body.appendChild(eleLink)
                    eleLink.click()
                    document.body.removeChild(eleLink)
                }
            }).finally(() => {
                this.isBtnLoading = false
            })
        },
        handlePrint () {
            this.isBtnLoading = true
            this.$post('/oms/client/entrustExport/printConfirmBillPdf', {ids: this.selected.map(e => e.id)}).then(res => {
                if (res.data.code == 'C0000') {
                    if (res.data.result) {
                        this.openFile(res.data.result)
                    } else {
                        this.$message({
                            type: 'success',
                            message: res.data.message,
                            offset: 380,
                            grouping: true,
                        })
                    }
                    
                }
            }) .finally(() => {
                this.isBtnLoading = false
            })
        },
        openFile (url) {
            window.open(url)
        },
        offlinePay(row) {
            this.goRemittance(row)
            // this.$router.push({
            //     path: '/payable-list',
            // })
        },
        goRemittance(row) {
            // this.selected[0] = row
            this.showApplyDetail(row)
        },
        getStatusTimeAxis (entrustId, bizType) {
            this.logvisible = true
            this.dataInfo = {entrustId,bizType}
            this.$nextTick(() => {
                this.$refs['logistics-status'].getStatusTimeAxis(this.dataInfo.entrustId,this.dataInfo.bizType)
            })
        },
        signClose () {
            this.getListData()
        },
        showDownDialog(row) {
            this.uploadParams.sourceBillId = row.id
            this.uploadParams.url = '/oms/client/entrustStatus/getAllNodesAttach'
            this.uploadParams.data = {entrustId: row.id, isShowOut: true}
            this.uploadParams.show = true
        },
        handlerUploadFile (row) {
            this.uploadParams.sourceBillId = row.id
            this.uploadParams.title = '账单下载'
            this.uploadParams.url = '/oms/client/entrustImport/deriveCalculatePdf'
            this.uploadParams.data = {id: row.id, isShowOut: true}
            this.uploadParams.show = true
        },
        handlerRevoke (row) {
            this.isloading = true
            this.$get('/oms/client/entrustImport/clientRevoke', {id: row.id}).then(res => {
                if (res.data && res.data.code === 'C0000') {
                this.$message({
                    type: 'success',
                    message: res.data.message,
                    offset: 380,
                    grouping: true,
                })
                this.getListData()
                }
            }).finally(() => {
                setTimeout(() => {
                this.isloading = false
                })
            })
        },
        repairNumber(row) {
            this.repairDialog.id = row.id
            this.repairDialog.number = row.custOrderNo
            this.repairDialog.supplierMethod = '03'
            this.repairNumberVisible = true
        },
        confirmDialog() {
            this.$refs['repairDialog'].validate((valid) => {
                if (valid) {
                this.supplierLoading = true
                this.$set(this.repairDialog, 'supplierCarrierName', this.listCarrier.filter(e=>e.id == this.repairDialog.supplierCarrierId)[0].name)
                this.$post('/oms/client/entrustImport/fillCourierNumber', this.repairDialog).then(({data}) => {
                    this.$message({
                        type: data.code === 'C0000' ? 'success' : 'error',
                        message: data.message,
                        offset: 380,
                        grouping: true,
                    })
                    if(data && data.code === 'C0000') {
                    this.repairNumberVisible = false
                    this.getListData()
                    }
                }).finally(() => {
                    this.supplierLoading = false
                })
                }
            })
        },
        getclientGetDDL() {
            this.$get('/tms/track17/listCarrier', {data: {}}).then(({data}) => {
                if(data && data.code === 'C0000') {
                    this.listCarrier = data.result
                }
            })
        },
        closeDialog() {
            this.repairDialog = {supplierCarrierId: ''}
            this.$refs['repairDialog'].resetFields()
        },
        changeTimeRange (obj) {
            if (obj) {
                this.formSearch.bizDateBegin = obj[0] + ' 00:00:00'
                this.formSearch.bizDateEnd = obj[1] + ' 23:59:59'
            } else {
                this.formSearch.bizDateBegin = ''
                this.formSearch.bizDateEnd = ''
            }
            this.searchForm()
        },
        delRow(row) {
            this.selected[0] = row
            this.handlerDelete()
        },
        getBusinessStatus (row) {
            if (row.businessStatusDesc == '-') {
                return false
            }
            this.getStatusTimeAxis(row.id, row.bizType)
        },
        fileTypeChange(value) {
            if (value.includes('ALL_SELECT')) { // 全选
                this.fileType = this.fileTypeList.map(e => e.value)
            }
        },
        downloadFiles() {
            console.log(this.fileUploadList)
            let fileType = []
            this.fileUploadList.map(e => {
                this.fileTypeList.map(y => {
                    if (e == y.desc) {
                        fileType.push(y.value)
                    }
                })
            })
            this.$post('/oms/billAttach/compressByAttachTypes', {
                isSync: true,
                sourceBillIdList: this.selected.map(e => e.id),
                sourceAttachTypeList: fileType        
            }, this, 'dlBtnLoading').then(({ data }) => {
                if (data && data.code === 'C0000') {          
                if (data.message) {
                    window.open(data.message)
                }
                }
            })
        },
        handleCheckAllChange (val) {
            this.fileUploadList = val ? this.fileTypeList.map(e => {return e.desc}) : []
        },
        handleCheckedCitiesChange (value) {
            const checkedCount = value.length
            const cities = this.fileTypeList.map(e => {return e.desc})
            this.checkAll = checkedCount === cities.length
            this.isIndeterminate = checkedCount > 0 && checkedCount < cities.length
        },
        getStatusList (type) {
            this.$get('/oms/client/entrustImport/statusList').then(({data}) => {
                if (data && data.code === 'C0000') {
                    this.exportStatus = data.result.exportStatus
                    this.formSearch.businessStatusList = []
                    if(type) {
                        switch (type) {
                            case 'all':
                            this.exportStatus.forEach(e=>{
                                if(e.value != 'finished') {
                                    this.formSearch.businessStatusList.push(e.value)
                                }
                            })
                                break;
                            case 'declare':
                                this.formSearch.businessStatusList = ['ordered', 'hk_stored', 'import_hk_stored', 'stowaged', 'declared']
                                break;
                            case 'warehouse':
                            this.formSearch.businessStatusList = ['ordered']
                                break;
                        
                            default:
                                break;
                        }
                        this.getListData()
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss">
.orders-prop {
  .el-steps--horizontal {
    padding: 17px 10px 10px 10px;
     .el-step__main .el-step__description {
      padding-left: 10%!important;
      padding-right: 0!important;
    }
  }
   .el-step__description {
    padding-left: 10%!important;
    padding-right: 0!important;
  }            
  .el-step__head.is-finish{
    color: #0b7aff;
    border-color: #0b7aff;
  }
  .el-step__head{
    .el-step__line{
      height: 2px;
      background-color: #edf2f6;
    }
  }
  .el-step__main{
    .is-finish{
      color: #0b7aff;
    }
  } 
}
.export-orders-list {
    .merge-input{
        .el-input__wrapper,.el-input__inner{
            height: 45px !important;
        }
    }
    .batch-download {
        display: inline-block;
     
        margin-left: 20px;
       
        .el-select {
            width: 250px;
            margin-right: 20px;
            .el-input {
               
                .el-input__suffix-inner .el-select__caret {
                    vertical-align: top;
                }
            }
        }
    }
    
}
.file-popover {
    .el-checkbox-group{
        margin-left: 10px;
    }
    // .el-checkbox:first-child {
    //     margin-left: 10px;
    // }
    .el-button {
        margin: 10px 0 10px 10px;
        border-color: #0A7CFF;
        color: #0A7CFF;
        width: 125px;
    }
}
</style>

